<template>
  <div class="toggle-container d-flex align-center justify-center" data-png-ignore>
    <v-tooltip location="bottom" content-class="race-by-stage-toggle-tooltip">
      <template #activator="{ props }">
        <button v-bind="props" class="toggle" type="button" @click="$emit('toggleStages')">
          <v-icon :icon="isExpanded ? '$minus' : '$plus'" size="14px" />
          {{ isExpanded ? 'Collapse stages' : 'Show more stages' }}
        </button>
      </template>
      {{ isExpanded ? 'Collapse hiring stages' : 'Show all hiring stages' }}
    </v-tooltip>
  </div>
</template>

<script setup>
defineProps({
  isExpanded: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['toggleStages']);
</script>

<style scoped lang="less">
.toggle-container {
  width: calc(100% - 86px);
}

.toggle {
  display: flex;
  height: 22px;
  background: @bg-canvas;
  border-radius: 24px;
  padding: 8px 10px;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: @text-darkest;
}
</style>
